import { useRecordAppDownload } from "hooks/useRecordAppDownload";
import { useEffect, useState } from "react";

export const usePWAInstall = () => {
  const [deferredPrompt, setDeferredPrompt] = useState(null);
  const [canInstall, setCanInstall] = useState(false);

  const { mutate: recordInstall } = useRecordAppDownload();

  useEffect(() => {
    const beforeInstallHandler = (e) => {
      e.preventDefault();
      setDeferredPrompt(e);
      setCanInstall(true);
    };

    const installedHandler = () => {
      recordInstall({
        appVersion: window.__APP_VERSION__ ?? null,
        source: "pwa-install-button",
      });
    };

    window.addEventListener("beforeinstallprompt", beforeInstallHandler);
    window.addEventListener("appinstalled", installedHandler);

    return () => {
      window.removeEventListener("beforeinstallprompt", beforeInstallHandler);
      window.removeEventListener("appinstalled", installedHandler);
    };
  }, [recordInstall]);

  const installApp = async () => {
    if (!deferredPrompt) return;

    deferredPrompt.prompt();
    await deferredPrompt.userChoice;

    setDeferredPrompt(null);
    setCanInstall(false);
  };

  return { canInstall, installApp };
};

// export const usePWAInstall = () => {
//   const [deferredPrompt, setDeferredPrompt] = useState(null);
//   const [canInstall, setCanInstall] = useState(false);

//   const { mutate: recordInstall } = useRecordAppDownload();

//   useEffect(() => {
//     const handler = (e) => {
//       e.preventDefault();
//       setDeferredPrompt(e);
//       setCanInstall(true);
//     };
//     window.addEventListener("beforeinstallprompt", handler);

//     return () => window.removeEventListener("beforeinstallprompt", handler);
//   }, []);

//   const installApp = async () => {
//     if (!deferredPrompt) return;
//     deferredPrompt.prompt();
//     const { outcome } = await deferredPrompt.userChoice;
//     console.log("User response:", outcome);
//     setDeferredPrompt(null);
//     setCanInstall(false);
//   };

//   return { canInstall, installApp };
// };
